import { SearchReservationState, SearchReservationActionTypes, SEARCH_RESERVATION_REQUEST, SEARCH_RESERVATION_SUCCESS, SEARCH_RESERVATION_FAILURE } from "store/reducers/lodgingOption/searchReservation/types";

const defaultState: SearchReservationState = {
  isLoading: false,
  errorMessage: ""
};

export default function searchReservation(state = defaultState, action: SearchReservationActionTypes): SearchReservationState {
  switch (action.type) {
    case SEARCH_RESERVATION_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case SEARCH_RESERVATION_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case SEARCH_RESERVATION_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};